import { supportedLocales } from '../I18n';

const visibleFields = ['title', 'description', 'problematic', 'localisation_label', 'budget'];

const fieldNames: Record<string, string[]> = {
  title: supportedLocales.map((locale: any) => `title_${locale}`),
  description: supportedLocales.map((locale: any) => `description_${locale}`),
  problematic: supportedLocales.map((locale: any) => `problematic_${locale}`),
  localisation_label: ['location'],
};

const fieldNameFromKey = (key: any) => {
  return Object.keys(fieldNames).find((name) => fieldNames[name].includes(key)) || key;
};

const filteredAudits = (audits: Array<any> = []) => {
  // remove non displayed fields from audit changes
  // and then remove audits with no changes
  return audits
    .map((audit) => ({
      ...audit,
      changes: Object.entries(audit.changes)
        .filter(([key]) => visibleFields.includes(fieldNameFromKey(key)))
        .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {}),
    }))
    .filter((audit) => Object.keys(audit.changes).length > 0);
};

export { fieldNameFromKey, filteredAudits };
